import { createFileRoute, Outlet, notFound } from "@tanstack/react-router";
import { getState } from "@/data/states";

export const Route = createFileRoute("/dscr-loans/$state")({
  loader: ({ params }) => {
    const state = getState(params.state);
    if (!state) throw notFound();
    return { state };
  },
  component: () => <Outlet />,
});
